module.exports = __webpack_public_path__ + "img/ResourceStone_ua.b5628cde.webp";